import React, {PureComponent} from "react"

import linkedCardService from "@irati/perksgo/services/linkedcards"
import authentication from "@irati/auth"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import {Deal} from "@irati/types"
import {LangLoader} from "@irati/utils/lang"
import {PERKSGO} from "@irati-web/app/src/routeConfig"

import HasCardBlock from "./HasCardBlock"

import {
  PerksGOBackground,
  PerksGOWrapper
} from "./styled"

interface Props {
  deal: Deal,
  linkedCards: []
}

interface State {
  load: Promise<any>,
  hasLinkedCards?: boolean
}

class PerksGOImportantInfo extends PureComponent<Props, State> {
  state: State = {
    load: hangPromise(),
    hasLinkedCards: undefined
  }

  componentDidMount = () => {
    this.setState({load: this.hasLinkedCards()})
  }

  hasLinkedCards = () => {
    const userId = authentication.user().uuid
    return linkedCardService.getPerksGOCards({userId}).then((linkedCards) => {
      this.setState({hasLinkedCards: linkedCards.length > 0})
    })
  }

  render() {
    const {deal} = this.props
    const {load, hasLinkedCards} = this.state
    return (
      <LangLoader bucket={PERKSGO}>
        <Loading load={load}>
          {hasLinkedCards && (
            <PerksGOBackground>
              <PerksGOWrapper direction="column" padding="30px 20px">
                <HasCardBlock isPerksGoRetailDeal={deal?.isPerksGoRetailDeal} dealExternalLinks={deal?.externalLinks} />
              </PerksGOWrapper>
            </PerksGOBackground>
          )}
        </Loading>
      </LangLoader>
    )
  }
}

export default PerksGOImportantInfo
